// 국가 목록 — country-flag-emoji-json(플래그 이모지 + ISO 3166-1 alpha-2 코드) 기반.
// 국가명은 브라우저 네이티브 Intl.DisplayNames로 현재 로케일(ko/en/ja) 현지화하고,
// 미지원 코드(어센션섬 등)는 라이브러리 영문명으로 폴백한다. (직접 구현 X)
import countryFlagEmoji from "country-flag-emoji-json";

const RAW = countryFlagEmoji.default || countryFlagEmoji;

// 로케일별 현지화 + 가나다/ABC 정렬된 국가 배열 반환: [{ code, emoji, name }]
export function listCountries(locale = "en") {
  let display = null;
  try {
    display = new Intl.DisplayNames([locale], { type: "region" });
  } catch (e) {
    display = null; // 구형 환경: 영문명 폴백
  }

  const localize = (c) => {
    if (!display) return c.name;
    try {
      return display.of(c.code) || c.name;
    } catch (e) {
      return c.name;
    }
  };

  return RAW.map((c) => ({ code: c.code, emoji: c.emoji, name: localize(c) })) //
    .sort((a, b) => a.name.localeCompare(b.name, locale));
}

// 단일 국가 조회(이모지 표시용). 미존재 시 null.
export function findCountry(code) {
  if (!code) return null;
  return RAW.find((c) => c.code === code) || null;
}
